module.exports = __webpack_public_path__ + "img/weixin.d389ead0.jpg";